module.exports = __webpack_public_path__ + "static/media/favicon.9518f181.png";